import * as React from 'react';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';

import { AutocompleteListDataService } from 'src/core/ui/autocomplete/autocomplete.data';
import { QuotePaxView } from './quote-pax.view';
import { QuotePaxDataService } from './quote-pax-form.data';
import { FormatService } from 'src/core/services/format.service';

interface QuotePaxControllerProps extends ComponentViewProps<QuoteItem> {
	identityService: any;
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	contextService: any;
	formatService: FormatService;
	dataService: QuotePaxDataService;
	newQuotePax: (quote: QuoteItem, client?: ClientItem) => any;
	billing: BillingItem[];
	deletePaxs: (paxsDelete: QuotePaxItem[]) => Promise<boolean>;
	hideIcons?: boolean;
	handleEditQuotePaxField: (quotePax: QuotePaxItem, requireUpdatePrice: boolean, requirePolicyChecking: boolean) => Promise<void>;
	defaultLanguage: string;
}

@observer
export class QuotePaxController extends React.Component<QuotePaxControllerProps, any> {

	protected nationalityDataService: AutocompleteListDataService;
	protected documentTypeDataService: AutocompleteListDataService;

	constructor(props) {
		super(props);

		this.nationalityDataService = AutocompleteListDataService.make();
		this.documentTypeDataService = AutocompleteListDataService.make();
	}

	render() {
		if (this.props.dataService == null || this.props.dataService.items == null) {
			return null;
		}

		return (
			<QuotePaxView
				formatService={this.props.formatService}
				quote={this.props.model}
				mode={this.props.mode}
				model={this.props.dataService}
				billing={this.props.billing}
				newQuotePax={this.props.newQuotePax}
				setBusy={this.props.setBusy}
				attachClient={this.attachClient}
				deletePaxs={this.props.deletePaxs}
				handleEditQuotePaxField={this.props.handleEditQuotePaxField}
				nationalityQuery={{ query: this.nationalityQuery, dataSet: this.nationalityDataService }}
				documentTypeQuery={{ query: this.documentTypeQuery, dataSet: this.documentTypeDataService }}
				identityService={this.props.identityService}
				defaultLanguage={this.props.defaultLanguage}

			/>
		);
	}

	@autobind
	private attachClient(pax: QuotePaxItem, client: ClientItem) {
		const model = client.dynamicProperties["person"] as PersonItem;
		pax.clientId = client.id;
		pax.clientDisplayName = client.displayName;
		if (pax.dynamicProperties['salutation'] == '')
			pax.dynamicProperties['salutation'] = model.salutation;
		if (pax.dynamicProperties['foreName'] == '')
			pax.dynamicProperties['foreName'] = model.firstName;
		if (pax.dynamicProperties['middleName'] == '')
			pax.dynamicProperties['middleName'] = model.middleName;
		if (pax.dynamicProperties['surName'] == '')
			pax.dynamicProperties['surName'] = model.lastName;
		if (this.props.formatService.toString("small-date", pax.dynamicProperties['birthDate']) == this.props.formatService.toString("small-date", new Date()))
			pax.dynamicProperties['birthDate'] = new Date(model.birthDate);
		if (pax.dynamicProperties['gender'] == '')
			pax.dynamicProperties['gender'] = model.gender;

		if (this.props.billing.find(x => x.id == client.id) == null) {
			this.props.billing.push({ id: client.id, displayName: client.displayName });
		}

	}

	private nationalityQuery = (q?: string) => {
		return new Promise<QueryResult<AutocompleteSummary>>((resolve, reject) => {
			this.nationalityDataService.addFilter('concept', 'eq', 'nationality');
			this.nationalityDataService.addFilter('key', 'eq', 'nationality');
			this.nationalityDataService.addSorting('value', 'asc', true);
			this.nationalityDataService.searchKeywords = q;
			this.nationalityDataService.pageSize = 100;
			return this.nationalityDataService
				.load(query => query)
				.then((items) => {
					this.props.setBusy(false);
					resolve({ items: items, totalCount: this.nationalityDataService.totalPages });
				})
				.catch((error) => {
					this.props.setBusy(false);
					reject(error);
				});
		});
	}

	private documentTypeQuery = (q?: string) => {
		return new Promise<QueryResult<AutocompleteSummary>>((resolve, reject) => {
			this.documentTypeDataService.addFilter('concept', 'eq', 'client');
			this.documentTypeDataService.addFilter('key', 'eq', 'documentType');
			this.documentTypeDataService.addSorting('value', 'asc', true);
			this.documentTypeDataService.searchKeywords = q;
			this.documentTypeDataService.pageSize = 100;
			return this.documentTypeDataService
				.load(query => query)
				.then((items) => {
					this.props.setBusy(false);
					resolve({ items: items, totalCount: this.documentTypeDataService.totalPages });
				})
				.catch((error) => {
					this.props.setBusy(false);
					reject(error);
				});
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-paxs/quote-pax.controller.tsx